import Button from '@rio-cloud/rio-uikit/Button';
import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';

import CardSvg from '@/components/ui/svg/CardSvg';
import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';
import type { ChargingCardsStatusPanelProps } from '@/features/dashboard/types';
import { setLinkNavigation } from '@/hooks/usePageTracking';
import { t } from '@/lib/utils';
import { ADMINISTRATION_CARDS } from '@/routes/Router';
import { useUserStore } from '@/stores/userStore';

export const ChargingCardsStatusPanel = ({ cards, isLoading }: ChargingCardsStatusPanelProps) => {
    const { account } = useUserStore();

    const totalCardsActive = cards?.filter(card => card.isActive).length ?? 0;
    const totalCardsInactive = (cards?.length ?? 0) - totalCardsActive;

    const isAccountAbleToWrite = account?.permissions?.includes('emsp-cards.write');

    const navigate = useNavigate();

    const handleOrderClick = () => {
        navigate('?modal=orderCards&modalSource=overview_page');
    };

    const handleNavigationLink = () => {
        setLinkNavigation();
        trackCustomEvent(
            'open_charging_cards_link',
            {
                trigger: 'click',
                flow_name: 'overview',
                element_name: 'charging_cards_link',
            },
            createDebugConfig()
        );
    };

    return (
        <div className='margin-bottom-10 margin-top-10 display-flex width-100pct flex-column'>
            <div className='display-flex width-100pct flex-row gap-20'>
                <div className='panel display-flex width-100pct padding-20'>
                    {isLoading ? (
                        <ContentLoader className='margin-y-10 width-100pct' />
                    ) : (
                        <>
                            <div className='display-flex flex-1-1-0 flex-wrap align-items-center column-gap-10'>
                                <p className='margin-y-0 display-flex align-items-center column-gap-5'>
                                    <CardSvg />
                                    <strong>{cards?.length ?? 0} </strong>
                                    {t('general.chargingCards')}
                                </p>

                                <span className='border-color-dark border-left-only border-width-1 height-15 border text-center' />
                                <p className='margin-0 display-flex align-items-center '>
                                    <span className='rioglyph rioglyph-ok-sign text-color-success text-size-16' />
                                    {t('general.active')} (<strong>{totalCardsActive}</strong>)
                                </p>

                                <p className='margin-0 display-flex align-items-center '>
                                    <span className='rioglyph rioglyph-remove-sign text-size-16' />
                                    {t('general.inactive')} (<strong>{totalCardsInactive}</strong>)
                                </p>
                            </div>
                            <div className='display-flex align-items-center gap-10'>
                                <Link
                                    className='btn btn-default'
                                    to={ADMINISTRATION_CARDS}
                                    onClick={handleNavigationLink}
                                >
                                    {t(
                                        isAccountAbleToWrite
                                            ? 'overview.manageChargingCards'
                                            : 'overview.manageChargingCards.fleetUser'
                                    )}
                                </Link>
                                {isAccountAbleToWrite && (
                                    <Button className='btn btn-primary' onClick={handleOrderClick}>
                                        <span className='rioglyph rioglyph-plus' aria-hidden='true' />
                                        <span>{t('general.orderChargingCard')}</span>
                                    </Button>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
